<template>
  <b-container class="bv-example-row" style="color: rgb(37, 91, 48)">
        <p class="title" style="color: rgb(37, 91, 48)">Building <span style=" color: rgba(240, 206, 13, 0.937); margin-left: 10px;">Managment</span></p>
        <b-card >
          <b-row no-gutters style="padding: 15px; display: flex; justify-content: center; align-items: center;">
              <b-card-img :src="require('../../assets/Tsehay_logo_big.png')" alt="Image" class="rounded-0" style="width: 150px;height: 150px;"> 
              </b-card-img>
          </b-row>
          <b-row no-gutters>
          <b-col md="12" style="display: grid; justify-content: center; align-items: center;">
              <b-card-body title=""> 
                  <b-form class="text-left" @submit="onSubmit">
                      <label for="text-username">User Name</label>
                      <b-form-input type="text" id="text-username"  class="mb-3 mr-sm-2" v-model="user.userName" required></b-form-input>
                      <b-button type="submit" variant="primary" style="color: rgb(37, 91, 48);font-weight: 600; " :disabled="searchFlag">Submit</b-button>
                      <!-- <b-button to="/KYC/registerUser" variant="outline-primary" class="outline-primary">Register</b-button> -->
                  </b-form>
              </b-card-body>
          </b-col>
          </b-row>
        </b-card>
    </b-container>
</template>

<script>
export default {
    data(){
        return{
            user:{
                userName: '',
            },
            searchFlag: false
        }
    },
    mounted(){
    },
    methods:{
        onSubmit(event){
            event.preventDefault();
            this.$store.dispatch('resetPassword', {userName: this.user.userName})
            .then(response =>{
                this.$router.push({name: 'Login'});
            })
            .catch(error =>{
                this.$notifications.notify(
                {
                    message: error.response.data,
                    horizontalAlign: 'center',
                    verticalAlign: 'top',
                    type: 'danger'
                })
            })
            .finally(msg=>{
                this.searchFlag = false;
            })
            //this.$router.push({name: 'Overview'});
        }
    },
}
</script>

<style scoped>
.bv-example-row{
    margin-top: 6%;
}
.form-control{
    padding: 10px;
}
.btn-primary{
    background: rgba(240, 206, 13, 0.937);
    border-color: rgba(240, 206, 13, 0.937);
    width: 100%;
}
.outline-primary{
    border-color: rgba(240, 206, 13, 0.937);
    color: rgba(240, 206, 13, 0.937);
    margin-left: 10px;
    background: transparent;
}
.outline-primary:hover {
    background: rgba(240, 206, 13, 0.937);
    color: #FFF;
}
.card{
    width: 100%;
    height: 100%;
}
.card-body{
    padding-top: 0;
    padding-bottom: 0;
}
.row > *{
    padding: 0 0;
}
.row {
    --bs-gutter-x: 2rem;
}
.bv-example-row{
     display: grid;
    justify-content: center;
    align-items: center;
}
.title{
    display: flex;
    justify-content: center;
    font-size: 30px;
    font-family: monospace;
    font-weight: bold;
}
.unhide{
    border: 1px solid #ced4da;
    color: rgb(37, 91, 48); 
    height: 100%;
}
@media (max-width: 768px) {
    .unhide{
        height: 80%;
    }
}
</style>